import Section from '~/components/common/Section';

function History() {
    return (
        <Section title="History">
            <p>
                I had the idea for the game during my first year at Hue University of Sciences. After discussing it with
                a few friends, development officially began in the summer of 2022. Inspired by the journey in{' '}
                <strong>Far: Lone Sails</strong> and the unique storytelling of <strong>Limbo</strong>,{' '}
                <strong>The Ghost of Lake</strong> is a 2D side-scrolling action game. It features a unique narrative
                that delves into themes of family, psychology, and love. The game will be released later this year.
            </p>
        </Section>
    );
}

export default History;
